import bitcoin from '../images/values/bitcoin.png';
import education from '../images/values/education.png';
import sovereignty from '../images/values/sovereignty.png';
import experimentation from '../images/values/experimentation.png';
import foss from '../images/values/foss.png';
import access from '../images/values/access.png';
import sustainability from '../images/values/sustainability.png';
import voluntarism from '../images/values/voluntarism.png';

const values = [
  {
    value: 'Bitcoin Standard',
    img: bitcoin,
    description:
      'Bitcoin, the hardest money, is our medium of exchange and store of value.',
  },
  {
    value: 'Education',
    img: education,
    description:
      'Content and events centered around wellness, generational healing, and censorship resistent tech.',
  },
  {
    value: 'Sovereignty',
    img: sovereignty,
    description:
      'Taking responsibility for your finances, health, and actions.',
  },
  {
    value: 'Sustainability',
    img: sustainability,
    description:
      'Give more to the world than we take. Use low-time-preference thinking to leave a positive impact on the world.',
  },
  {
    value: 'Experimentation',
    img: experimentation,
    description:
      'Being on the frontier calls for an adventurous mindset, and the utilization of mind and body to the fullest.',
  },
  {
    value: 'Voluntarism',
    img: voluntarism,
    description:
      'The Psitadel should only operate on a voluntarist and permission-less basis.',
  },
  {
    value: 'FOSS',
    img: foss,
    description:
      'Increase censorship resistance, custody our data, and decrease our reliance of centralized points of failure',
  },
  {
    value: 'Access',
    img: access,
    description:
      'Access to natural medicines and integration services for a complete holistic mental/spiritual health solution.',
  },
];

export default values;
